import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import PublicPage from "@/PublicPage";

const AdminApp = lazy(() => import("@/admin/AdminApp"));

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/mallorca" replace />} />
        <Route path="/es" element={<Navigate to="/es/mallorca" replace />} />
        <Route path="/admin/*" element={<Suspense fallback={null}><AdminApp /></Suspense>} />
        <Route path="*" element={<PublicPage />} />
      </Routes>
    </BrowserRouter>
  );
}
